var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08033 0.672509C8.5112 0.241796 9.09553 -0.000112474 9.70476 3.92301e-08C10.314 0.000112552 10.8982 0.242237 11.3289 0.673109C11.7597 1.10398 12.0016 1.68831 12.0014 2.29754C12.0013 2.90677 11.7592 3.49101 11.3283 3.92172L11.0476 4.20249L7.79956 0.954476L8.08033 0.672509ZM6.95126 1.80277L0.778004 7.97483C0.694679 8.05854 0.637914 8.16497 0.614824 8.2808L0.0100961 11.2804C-0.00963259 11.3774 -0.00507928 11.4777 0.0233505 11.5725C0.0517803 11.6672 0.103204 11.7535 0.173042 11.8236C0.24288 11.8936 0.328965 11.9454 0.423629 11.9741C0.518293 12.0029 0.618598 12.0078 0.715612 11.9884L3.72005 11.3884C3.83602 11.365 3.94247 11.3078 4.02601 11.224L10.1993 5.05079L6.95126 1.80277Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPencil);
export default __webpack_public_path__ + "static/media/ic-pencil.2d82a84c70b2acc2d25a07bf407b8ab9.svg";
export { ForwardRef as ReactComponent };